import { render, staticRenderFns } from "./assets-table.vue?vue&type=template&id=5fbe89fb&scoped=true"
import script from "./assets-table.vue?vue&type=script&lang=js"
export * from "./assets-table.vue?vue&type=script&lang=js"
import style0 from "./assets-table.vue?vue&type=style&index=0&id=5fbe89fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbe89fb",
  null
  
)

export default component.exports